import { Button } from 'react-bootstrap';
import { stepButtonStyles, stepLabelStyles, stepNumberStyles, stepperContainerStyles } from './styles';

const FormStepper = ({
    pages = [],
    pageNames = [],
    currentPage = 0,
    onPageChange = () => {},
    fieldPageMap = {},
    errors = {},
    validationPerPage = false,
}) => {
    const getPageStatus = (pageIndex) => {
        // Determine status of each page: 'default', 'error', 'success'
        const fieldsOnPage = Object.entries(fieldPageMap)
            .filter(([_, index]) => index === pageIndex)
            .map(([fieldName]) => fieldName);

        const hasError = fieldsOnPage.some((field) => errors[field]);
        if (hasError) return 'error';

        if (currentPage > pageIndex) return 'success';
        return 'default';
    };

    return (
        <div css={stepperContainerStyles}>
            {pages.map((_, index) => {
                return (
                    <Button
                        key={index}
                        variant={index === currentPage ? 'primary' : ''}
                        onClick={() => onPageChange(index)}
                        css={stepButtonStyles}
                    >
                        <span css={stepNumberStyles(getPageStatus(index))}>{index + 1}</span>

                        <span css={stepLabelStyles}>{pageNames ? pageNames[index] : `Page ${index + 1}`}</span>
                    </Button>
                );
            })}
        </div>
    );
};

export default FormStepper;
